export class CurrencyRate {
  rate: number;
  code: string;
  currencyUpdateTime: Date;
}
